import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Box, Checkbox, Divider, ListItemText, Pagination } from '@mui/material';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Tooltip, Chip, Typography, FormControl, TextField, InputLabel, Select, MenuItem, Backdrop, CircularProgress, Autocomplete, CardActions } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import Customers from './Customers';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { DataGrid, GridRowParams, GridValueGetterParams,GridActionsCellItem, GridCellParams, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, ArrowDownward, AccessTime, PersonOutline, HistoryOutlined, CancelPresentationOutlined } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { toast, ToastContainer } from 'react-toastify';

import { formatDate } from '../../helpers/custom';

function CustomToolbar() {
    return (
        <GridToolbarContainer className='exportButton'>
            <GridToolbarExport variant='contained' csvOptions={{ fileName: 'Tickets-list', allColumns: true, }}  />
        </GridToolbarContainer>
    );
}
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
        
        
        
        />
    );
}
export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    tickets: any[];
    pageSize: number;
    filter: any;
    status: any[];
    start_date: any;
    end_date: any;
    community: any;
    page: any;
    type: any;
    showLoader: any;
    routes: any;
    rowCount: any;
    currentPage: number;
    statusOpen:boolean;
    tempStatus:any[];
}

class TicketsList extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            tickets: [],
            pageSize: 10,
            tempStatus: ['open', 'inProgress'],
            statusOpen: false,  
            filter: '',
            status: ['open', 'inProgress'],
            currentPage: 0, 
            start_date: null,
            end_date: null,
            community: '',
            page: 0,
            type: 'all',
            showLoader: false,
            routes: [],
            rowCount: 0,
        }
    }
    public componentDidMount(): void {
        // axios.get(`tickets`).then(response => {
        //     this.setState({ tickets: response.data.data })
        // });
        // this.setState({
        //     tickets: [
        //         {
        //             "id": 139,
        //             "customer_name": "Pt Sicepat",
        //             "type": "Weight",
        //             "query": "Weight is not correct.",
        //             "pickup_date_agent": "2021-10-25 / Luh Ayu Manik Mas",
        //             "created_at": "2021-10-25 12:32:36",
        //             "status": "Closed"
        //         },
        //         {
        //             "id": 138,
        //             "customer_name": "Gede Setriawan",
        //             "type": "Payment",
        //             "query": "Payment got failed.",
        //             "pickup_date_agent": "2021-10-25 / Luh Ayu Manik Mas",
        //             "created_at": "2021-10-25 12:32:36",
        //             "status": "Closed"
        //         },
        //         {
        //             "id": 137,
        //             "customer_name": "Ketut Kerta Yoga",
        //             "type": "Missed Pickup",
        //             "query": "Pickup didn't happened.",
        //             "pickup_date_agent": "2021-10-25 / Luh Ayu Manik Mas",
        //             "created_at": "2021-10-25 12:32:36",
        //             "status": "In Progress"
        //         },
        //         {
        //             "id": 136,
        //             "customer_name": "I Wayan Suartama",
        //             "type": "Missed Bag",
        //             "query": "My bag is missing.",
        //             "pickup_date_agent": "2021-10-25 / Luh Ayu Manik Mas",
        //             "created_at": "2021-10-25 12:32:36",
        //             "status": "In Progress"
        //         },
        //         {
        //             "id": 135,
        //             "customer_name": "Pt Sicepat",
        //             "type": "Account Issue",
        //             "query": "Not able to login to my account.",
        //             "pickup_date_agent": "2021-10-25 / Luh Ayu Manik Mas",
        //             "created_at": "2021-10-25 12:32:36",
        //             "status": "Open"
        //         },
        //         {
        //             "id": 134,
        //             "customer_name": "Gede Setriawan",
        //             "type": "Agent Issue",
        //             "query": "Agent didn't came to collect the waste.",
        //             "pickup_date_agent": "2021-10-25 / Luh Ayu Manik Mas",
        //             "created_at": "2021-10-25 12:32:36",
        //             "status": "Open"
        //         },
        //         {
        //             "id": 133,
        //             "customer_name": "Ketut Kerta Yoga",
        //             "type": "Other",
        //             "query": "Not able to change my mobile number",
        //             "pickup_date_agent": "2021-10-25 / Luh Ayu Manik Mas",
        //             "created_at": "2021-10-25 12:32:36",
        //             "status": "Open"
        //         }
        //     ]
        // })
        this.fetchRoutes();
        this.fetchTicketList();
    }

    public fetchTicketList (page: any = this.state.page, limit: Number = this.state.pageSize) {
        this.setState({showLoader: true,currentPage: page});
        let body = {
            "hierarchies": this.props.user.selectedHierarchyIds,
            "start_date": this.state.start_date,
            "end_date": this.state.end_date,
            "filter": this.state.filter,
            "page": page+1,
            "limit": limit,
            // "status": (this.state.status != "all") ? this.state.status : "",
            "status": (this.state.status && this.state.status.length > 0) ? this.state.status : [],
            "type": (this.state.type != "all") ? this.state.type : "",
            "community_id": this.state.community,
        }
        axios.post('listAllTickets', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                console.log("data", response.data.data);
                let data = response.data.data.data;
                this.setState({tickets: data, showLoader: false, rowCount: response.data.data.total});
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public fetchRoutes(hierarchies: any = this.props.user.selectedHierarchyIds) {
        axios
          .get(`allCommunitiesLite`, { params: { hierarchies: hierarchies } })
          .then((response) => {
            let data: any = response.data.data;
            // let routes: any = [];
            // data.map((route: any) => {
            //   routes[route.id] = {
            //     id: route.id,
            //     route: route.name,
            //     generator: route.type,
            //   };
            // });
            this.setState({ routes: data });
            // console.log("routes", this.state.routes);
          });
    }

    public downloadTickets = () => {
        this.setState({ showLoader: true });
        let data: any = { "filter": this.state.filter }

        if (this.state.start_date && this.state.end_date) {
            data['start_date'] = this.state.start_date;
            data['end_date'] = this.state.end_date;
        }
        data["hierarchies"] = this.props.user.selectedHierarchyIds;
        if (this.state.community) {
            data['community_id'] = this.state.community;
        }
        axios.post('downloadTickets', data).then((response: any) => {
            this.setState({ showLoader: false });
            let fileName = "";
            if (this.state.start_date && this.state.end_date) {
                fileName = "Tickets-List-"+this.state.start_date+"-"+this.state.end_date+".csv";
            }else{
                fileName = "Tickets-List.csv";
            }
            
            const blob = new Blob([response.data], { type: response.headers['content-type'] });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
                position: "top-right",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const maskedCellSx = isUatEnvironment
            ? {
                filter: 'blur(4px)',
                opacity: 0.5,
                userSelect: 'none',
            }
            : undefined;
        const renderMaskedCell = (value: React.ReactNode) => (
            <Box component="span" sx={maskedCellSx}>
                {value}
            </Box>
        );

        const handleCellClick = (params: GridCellParams) => {
            console.log(params);
        };

        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 80
            }, 
            {
                headerName: "Customer",
                field: "user",
                width: 180,
                valueGetter: (params: GridValueGetterParams) => `${params.row?.user?.name}`, 
                renderCell: (params: GridCellParams) => (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={(event) => {
                            event.stopPropagation();  
                            if (params.row?.user?.id) {
        
                                //   window.location.href = `/neighbourhood/customers/${params.row.user.id}`;
                                window.open(`/neighbourhood/customers/${params.row.user.id}`, '_blank');
                            }
                          }}
                    >
                        {renderMaskedCell(
                            <>
                                {params.row?.user?.phone} / {params.row?.user?.name}
                            </>
                        )}
                    </span>
                )
            },
            {
                headerName: "City",
                field: "hierarchy_name",
                width: 120,
                renderCell: (params: GridCellParams) => (
                    <span>{params.row.hierarchy_name || "-"}</span>
                )
            },
            {
                headerName: "Community",
                field: "community",
                width: 150,
                valueGetter: (params: GridValueGetterParams) => `${params.row?.user?.community?.info?.name || 'No community'}`, 
                renderCell: (params: GridCellParams) => (
                    <span 
                        style={{ cursor: 'pointer' }}
                        onClick={(event) => {
                            event.stopPropagation();  
                            if (params.row?.user?.community?.info?.id) {
                                //   window.location.href = `/neighbourhood/community-list/${params.row?.user?.community?.info?.id}`;
                                window.open(`/neighbourhood/community-list/${params.row?.user?.community?.info?.id}`, '_blank');
                            }
                        }}
                    >
                        {renderMaskedCell(params.row?.user?.community?.info?.name)}
                    </span>
                )
            },
            {
                headerName: "BintixUid",  
                field: "user_id",       
                width: 150,    
                
                valueGetter: (params: GridValueGetterParams) => params.row?.user?.id || '-',  
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                        {params.row?.user?.id || '-'} 
                    </span>
                ),
                hide: true,
            },
            
            {
                headerName: "Type",
                field: "type",
                width: 120
            },
            {
                headerName: "Status",
                field: "status",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    // <Typography sx={{ fontWeight: 'bold' }} className={(params.row.status == 'closed') ? 'statusTextSuccess' : ((params.row.status == 'inProgress') ? 'statusTextWarning' : 'statusTextError')} style={{ cursor: 'pointer' }}>{params.row.status == "closed" ? "Closed" : params.row.status == "inProgress" ? "In Progress" : "Open"}</Typography>
                <Typography
                    sx={{ fontWeight: 'bold' }}
                    className={
                        params.row.status === 'closed'
                        ? 'statusTextSuccess'
                        : params.row.status === 'inProgress'
                        ? 'statusTextWarning'
                        : params.row.status === 'responded'
                        ? 'statusTextInfo'
                        : 'statusTextError'
                    }
                    style={{ cursor: 'pointer' }}
                    >
                    {params.row.status === 'closed'
                        ? 'Closed'
                        : params.row.status === 'inProgress'
                        ? 'In Progress'
                        : params.row.status === 'responded'
                        ? 'Responded'
                        : 'Open'}
                </Typography>

                )
            },
            {
                headerName: "Query",
                field: "ticket_query",
                width: 300,
                sortable: false,
                valueGetter: (params: GridValueGetterParams) => {
                    const isUnread = params.row?.ticket_query?.is_read === 0;
                    const message = params.row?.ticket_query?.message || "No message available";
            
                    return isUnread ? `Unread - ${message}` : message;
                },
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                      {(params.row?.ticket_query?.is_read === 0 || params.row?.messages?.[0]?.unread > 0) && (params.row.status != 'closed') && (
                        <Chip color="warning" label={params.row?.messages?.[0]?.unread || "Unread"} />
                      )}
                      {renderMaskedCell(params.row?.ticket_query?.message || "No message available")}
                    </span>
                  ),
                  
                // renderCell: (params: GridCellParams) => (
                //     <span style={{ cursor: 'pointer' }}>
                //       {params.row?.ticket_query?.is_read === 0 && (
                //         <Chip color="warning" label={params.row?.messages?.[0]?.unread || "Unread"} />
                //       )}
                //       {params.row?.ticket_query?.message || "No message available"}
                //     </span>
                // )
            },
            {
                headerName: "Closed At",
                field: "updated_at",
                type: "dateTime",
                width: 160,
                renderCell: (params: GridCellParams) => (
                    params.row.status === 'closed' && params.row.updated_at
                        ? <span>{params.row.updated_at}</span>
                        : <span>-</span>
                )
            },
            {
                headerName: "Pickup Date",
                field: "pickup_date",
                width: 100,
                valueGetter: (params: GridValueGetterParams) => params.row?.pickup_date || '-',
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                        {params.row?.pickup_date || '-'}
                    </span>
                )
            },
            {
                headerName: "Agent",
                field: "agent",
                width: 120,
                valueGetter: (params: GridValueGetterParams) => params.row?.agent || '-',
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                        {params.row?.agent || '-'}
                    </span>
                )
            },

            
            
            {
                headerName: "Created At",
                field: "created_at",
                type: "dateTime",
                width: 150
            },
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <NeighbourhoodHeader user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{height: 600}}>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        {/* <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Ticket List")}</Typography>
                                        </Grid> */}
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.fetchTicketList())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="route-type-label">{t("Status")}</InputLabel>
                                                <Select
                                                    labelId="route-type-label"
                                                    multiple
                                                    open={this.state.statusOpen}
                                                    onOpen={() => this.setState({ statusOpen: true })}
                                                    onClose={() => this.setState({ statusOpen: false })}
                                                    value={this.state.tempStatus || this.state.status}
                                                    // onChange={(e: any) => this.setState({ "status": e.target.value }, () => this.fetchTicketList())}
                                                    onChange={(e: any) => {
          
                                                        const value = e.target.value;
                                                        const allStatuses = ['open', 'inProgress', 'responded', 'closed'];
                                                        if (value.includes('all')) {
                                                            this.setState({ status: allStatuses });
                                                        } else {
                                                            this.setState({ status: value });
                                                        }
                                                    }}
                                                    renderValue={(selected) => 
                                                        (selected as string[]).map(s => 
                                                            s.charAt(0).toUpperCase() + s.slice(1)
                                                        ).join(', ')
                                                    } 
                                                    // displayEmpty
                                                    label={t("Status")}
                                                >
                                                    {/* <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                                                    <MenuItem key={'Open'} value={'open'}>{t("Open")}</MenuItem>
                                                    <MenuItem key={'In-progress'} value={'inProgress'}>{t("In Progress")}</MenuItem>
                                                    <MenuItem key={'Responded'} value={'responded'}>{t("Responded")}</MenuItem>
                                                    <MenuItem key={'Closed'} value={'closed'}>{t("Closed")}</MenuItem> */}
                                                <MenuItem value="all" onClick={() => {
                                                    const allStatuses = ['open', 'inProgress', 'responded', 'closed'];
                                                    const allSelected = (this.state.tempStatus || this.state.status).length === allStatuses.length;
                                                    this.setState({ tempStatus: allSelected ? [] : allStatuses });
                                                }}>
                                                    <Checkbox
                                                    checked={(this.state.tempStatus || this.state.status).length === 4}
                                                    indeterminate={(this.state.tempStatus || this.state.status).length > 0 &&
                                                                    (this.state.tempStatus || this.state.status).length < 4}
                                                    />
                                                    <ListItemText primary={t("All")} />
                                                </MenuItem>

                                                {/* ✅ Individual options */}
                                                {['open', 'inProgress', 'responded', 'closed'].map((status) => (
                                                    <MenuItem
                                                    key={status}
                                                    value={status}
                                                    onClick={() => {
                                                        let selected = [...(this.state.tempStatus || this.state.status)];
                                                        if (selected.includes(status)) {
                                                        selected = selected.filter((s) => s !== status);
                                                        } else {
                                                        selected.push(status);
                                                        }
                                                        this.setState({ tempStatus: selected });
                                                    }}
                                                    >
                                                    <Checkbox
                                                        checked={(this.state.tempStatus || this.state.status).includes(status)}
                                                    />
                                                    <ListItemText primary={t(status.charAt(0).toUpperCase() + status.slice(1))} />
                                                    </MenuItem>
                                                ))}
                                                <Divider />
                                                <Box display="flex" justifyContent="flex-end" px={1} py={1}>
                                                    <Button
                                                    size="small"
                                                    className='customCloseButton'
                                                    sx={{ mr: 1 }} 
                                                    onClick={() => this.setState({ statusOpen: false, tempStatus: this.state.status })}
                                                    >
                                                    {t("Cancel")}
                                                    </Button>
                                                    <Button
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => {
                                                        this.setState(
                                                        { status: this.state.tempStatus || this.state.status, statusOpen: false },
                                                        () => this.fetchTicketList()
                                                        );
                                                    }}
                                                    >
                                                    {t("OK")}
                                                    </Button>
                                                </Box>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="route-type-label">{t("Type")}</InputLabel>
                                                <Select
                                                    labelId="route-type-label"
                                                    value={this.state.type}
                                                    onChange={(e: any) => this.setState({ "type": e.target.value }, () => this.fetchTicketList())}
                                                    displayEmpty
                                                    label={t("Type")}
                                                >
                                                    <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                                                    <MenuItem key={'Weight'} value={'weight'}>{t("Weight")}</MenuItem>
                                                    <MenuItem key={'Payment'} value={'payment'}>{t("Payments")}</MenuItem>
                                                    <MenuItem key={'MissedPickup'} value={'missed pickup'}>{t("Missed Pickup")}</MenuItem>
                                                    <MenuItem key={'MissedBag'} value={'missed bag'}>{t("Missed Bag")}</MenuItem>
                                                    <MenuItem key={'AccountIssue'} value={'account issue'}>{t("Account Issue")}</MenuItem>
                                                    <MenuItem key={'AgentIssue'} value={'agent issue'}>{t("Agent Issue")}</MenuItem>
                                                    <MenuItem key={'PurchaseNewBag'} value={'purchase new bags'}>{t("Purchase new bag")}</MenuItem>
                                                    <MenuItem key={'RegularBagRequest'} value={'regular bag request'}>{t("Regular Bag Request")}</MenuItem>
                                                    <MenuItem key={'Other'} value={'other'}>{t("Other")}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        renderInput={(props) => <TextField {...props} size='small'/>}
                                                        label="Start Date"
                                                        views={['year', 'month', 'day']}
                                                        value={this.state.start_date}
                                                        onChange={(newValue: any) => this.setState({ start_date: formatDate(newValue, 'Y-m-d') }, () => this.fetchTicketList())}
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        renderInput={(props) => <TextField {...props} size='small'/>}
                                                        label="End Date"
                                                        views={['year', 'month', 'day']}
                                                        value={this.state.end_date}
                                                        onChange={(newValue: any) => this.setState({ end_date: formatDate(newValue, 'Y-m-d') }, () => this.fetchTicketList())}
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <Autocomplete
                                                id="combo-box-demo"
                                                fullWidth={true}
                                                size="small"
                                                options={this.state.routes}
                                                value={this.state.community?.id}
                                                onChange={(value: any, newValue: any) => this.setState({community: newValue.id}, () => this.fetchTicketList())}
                                                getOptionLabel={(options: any) => options.name}
                                                renderInput={(params) => <TextField {...params} label="Community" />}
                                            />
                                        </Grid>
                                    </Grid>
                                }
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Button size='medium' fullWidth={true} variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.downloadTickets()}>{t("Download")}</Button>
                                    </CardActions>
                                }
                            />


                            <CardContent>
                                <DataGrid
                                    aria-label="Tickets List"
                                    columns={columns}
                                    rows={this.state.tickets}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchTicketList(page)}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize }, () => this.fetchTicketList(0, newPageSize))}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{ height: 500 }}
                                    pagination
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        // Toolbar: CustomToolbar,
                                        Pagination: () => (
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => this.fetchTicketList(page-1)}
                                              
                                            />
                                        )
                                    }}
                                    componentsProps={{ toolbar: { csvOptions: { fileName: 'Tickets-list' } } }}
                                    // onRowClick={(params: GridRowParams) => {
                                    //     this.props.history.push('/neighbourhood/tickets/' + params.id)
                                    // }}
                                    onRowClick={(params: GridRowParams) => {
                                        window.open(`/neighbourhood/tickets/${params.id}`, '_blank');
                                    }}
                                    
                                    className="clickableList"
                                    paginationMode="server"
                                />
                            </CardContent>


                        </Card>
                    </Grid>
                </Grid>

            </div>
        )
    }
}

export default withRouter(withTranslation()(TicketsList))
